<ng-container *transloco="let convert;">
  <div>
    <nav class="edit-posting-nav" aria-labelledby="edit-posting-nav-user" role="navigation">
      <div class="edit-posting-nav__label" id="edit-posting-nav-vehicle">{{convert('sellModule.posting.editPostingNav.textVehicleInfo')}} </div>
      <ul class="edit-posting-nav__list">
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.INFO_DESCRIPTION ? activeClass : null">
            @if (showErrorIcon(EditPostingFormNames.INFO_DESCRIPTION)) {
              <div class="error-icon ">
                <app-error-icon class="required-item-error-message" [remValue]="'.75rem'"></app-error-icon>
              </div>
            }
            @if (showSuccessIcon(EditPostingFormNames.INFO_DESCRIPTION)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a data-track-elem="tab" data-track-trigger="switch" data-track-name="Basic Information" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.INFO_DESCRIPTION)"
            [ngClass]="{'edit-posting-nav__link--active': selectedPostingForm == EditPostingForms.INFO_DESCRIPTION,
                                'required-item-error-message' : showErrorIcon(EditPostingFormNames.INFO_DESCRIPTION)}" role="navigation"
              [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehicleInfoDes')">
              {{convert('sellModule.posting.editPostingNav.textBasicInfo')}}
            </a>
          </div>
        </li>
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.INFO_LOCATION ? activeClass : null">
            @if (showErrorIcon(EditPostingFormNames.INFO_LOCATION)) {
              <div class="error-icon">
                <app-error-icon class="required-item-error-message" [remValue]="'0.75rem'"></app-error-icon>
              </div>
            }
            @if (showSuccessIcon(EditPostingFormNames.INFO_LOCATION)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a data-track-elem="tab" data-track-trigger="switch" data-track-name="Location" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.INFO_LOCATION)"
            [ngClass]="{'edit-posting-nav__link--active': selectedPostingForm == EditPostingForms.INFO_LOCATION,
                              'required-item-error-message' : showErrorIcon(EditPostingFormNames.INFO_LOCATION)}"
              role="navigation"
              [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehicleInfoLocation')">
              {{convert('sellModule.posting.editPostingNav.taxtLocation')}}
            </a>
          </div>
        </li>
      </ul>
    </nav>
    <nav class="edit-posting-nav" aria-labelledby="edit-posting-nav-vehicle-features">
      <div class="edit-posting-nav__label" id="edit-posting-nav-vehicle-features">{{convert('sellModule.posting.editPostingNav.textOptionAndAccessories')}}</div>
      <ul class="edit-posting-nav__list">
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.OPTIONS_EXTERIOR ? activeClass : null">
            @if (showSuccessIcon(EditPostingFormNames.OPTIONS_EXTERIOR)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a [tabIndex]="disableLinksForHold ? -1 : 0" data-track-name="Exterior" data-track-elem="tab" data-track-trigger="switch" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.OPTIONS_EXTERIOR)"
              [ngClass]="selectedPostingForm == EditPostingForms.OPTIONS_EXTERIOR ? activeClass : null" role="navigation"
              [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehicleExterior')"
              [ngStyle]="{'pointer-events': disableLinksForHold ? 'none': 'auto', color: disableLinksForHold ? '#959595' : ''}">
              {{convert('sellModule.posting.editPostingNav.textExterior')}}
            </a>
          </div>
        </li>
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.OPTIONS_INTERIOR ? activeClass : null">
            @if (showSuccessIcon(EditPostingFormNames.OPTIONS_INTERIOR)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a [tabIndex]="disableLinksForHold ? -1 : 0" data-track-elem="tab" data-track-trigger="switch" data-track-name="Interior" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.OPTIONS_INTERIOR)"
              [ngClass]="selectedPostingForm == EditPostingForms.OPTIONS_INTERIOR ? activeClass : null" role="navigation"
              [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehicleInterior')"
              [ngStyle]="{'pointer-events': disableLinksForHold ? 'none': 'auto', color: disableLinksForHold ? '#959595' : ''}">
              {{convert('sellModule.posting.editPostingNav.textInterior')}}
            </a>
          </div>
        </li>
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.OPTIONS_MECHANICAL ? activeClass : null">
            @if (showSuccessIcon(EditPostingFormNames.OPTIONS_MECHANICAL)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a [tabIndex]="disableLinksForHold ? -1 : 0" data-track-elem="tab" data-track-trigger="switch" data-track-name="Mechanical" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.OPTIONS_MECHANICAL)"
              [ngClass]="selectedPostingForm == EditPostingForms.OPTIONS_MECHANICAL ? activeClass : null" role="navigation"
              [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehicleMechanical')"
              [ngStyle]="{'pointer-events': disableLinksForHold ? 'none': 'auto', color: disableLinksForHold?'#959595':''}">
              {{convert('sellModule.posting.editPostingNav.textMechanical')}}
            </a>
          </div>
        </li>
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.OPTIONS_ADDITIONAL ? activeClass : null">
            @if (showSuccessIcon(EditPostingFormNames.OPTIONS_ADDITIONAL)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a [tabIndex]="disableLinksForHold ? -1 : 0" data-track-elem="tab" data-track-trigger="switch" data-track-name="Full Description" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.OPTIONS_ADDITIONAL)"
              [ngClass]="selectedPostingForm == EditPostingForms.OPTIONS_ADDITIONAL ? activeClass : null" role="navigation"
              [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehicleFullDes')"
              [ngStyle]="{'pointer-events': disableLinksForHold ? 'none': 'auto', color: disableLinksForHold ? '#959595' : ''}">
              {{convert('sellModule.posting.editPostingNav.textFullDescription')}}
            </a>
          </div>
        </li>
      </ul>
    </nav>
    <nav class="edit-posting-nav" aria-labelledby="edit-posting-nav-vehicle-images">
      <div class="edit-posting-nav__label" id="edit-posting-nav-vehicle-images">{{convert('sellModule.posting.editPostingNav.textVehicleImage')}}</div>
      <ul class="edit-posting-nav__list">
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.IMAGES_PHOTOS ? activeClass : null">
            @if (showSuccessIcon(EditPostingFormNames.IMAGES_PHOTOS)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a [tabIndex]="disableLinksForHold ? -1 : 0" data-track-elem="tab" data-track-trigger="switch" data-track-name="Photos" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.IMAGES_PHOTOS)"
              [ngClass]="selectedPostingForm == EditPostingForms.IMAGES_PHOTOS ? activeClass : null" role="navigation"
              [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehiclePhoto')"
              [ngStyle]="{'pointer-events': disableLinksForHold ? 'none': 'auto', color: disableLinksForHold ? '#959595' : ''}">
              {{convert('sellModule.posting.editPostingNav.textPhotos')}}
            </a>
          </div>
        </li>
      </ul>
    </nav>
    <nav class="edit-posting-nav" aria-labelledby="edit-posting-nav-vehicle-disclosures">
      <div class="edit-posting-nav__label" id="edit-posting-nav-vehicle-disclosures">{{convert('sellModule.posting.editPostingNav.textVehicleDisclosures')}}</div>
      <ul class="edit-posting-nav__list">
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.DISCLOSURES_CONDITION ? activeClass : null">
            @if (showSuccessIcon(EditPostingFormNames.DISCLOSURES_CONDITION)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a data-track-elem="tab" data-track-trigger="switch" data-track-name="Condition" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.DISCLOSURES_CONDITION)"
              [ngClass]="selectedPostingForm == EditPostingForms.DISCLOSURES_CONDITION ? activeClass : null"
              role="navigation" [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehicleCondition')">
              {{convert('sellModule.posting.editPostingNav.textCondition')}}
            </a>
          </div>
        </li>
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.DISCLOSURES_DAMAGES ? activeClass : null">
            @if (showSuccessIcon(EditPostingFormNames.DISCLOSURES_DAMAGES)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a [tabIndex]="disableLinksForHold ? -1 : 0" data-track-elem="tab" data-track-trigger="switch" data-track-name="Damages" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.DISCLOSURES_DAMAGES)"
              [ngClass]="selectedPostingForm == EditPostingForms.DISCLOSURES_DAMAGES ? activeClass : null" role="navigation"
              [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehicleDamage')"
              [ngStyle]="{'pointer-events': disableLinksForHold ? 'none': 'auto', color: disableLinksForHold ? '#959595' : ''}">
              {{convert('sellModule.posting.editPostingNav.textDamages')}}
            </a>
          </div>
        </li>
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.DISCLOSURES_TIRES ? activeClass : null">
            @if (showErrorIcon(EditPostingFormNames.DISCLOSURES_TIRES)) {
              <div class="error-icon">
                <app-error-icon class="required-item-error-message" [remValue]="'0.75rem'"></app-error-icon>
              </div>
            }
            @if (showSuccessIcon(EditPostingFormNames.DISCLOSURES_TIRES)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a [tabIndex]="disableTires ? -1 : 0" data-track-elem="tab" data-track-trigger="switch" data-track-name="Tires" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.DISCLOSURES_TIRES)"
            [ngClass]="{'edit-posting-nav__link--active': selectedPostingForm == EditPostingForms.DISCLOSURES_TIRES,
                      'required-item-error-message' : showErrorIcon(EditPostingFormNames.DISCLOSURES_TIRES)}"
              [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehicleTires')"
              [ngStyle]="{'pointer-events': disableTires ? 'none': 'auto', color: disableTires ? '#959595' : ''}">
              {{convert('sellModule.posting.editPostingNav.textTires')}}
            </a>
          </div>
        </li>
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.DISCLOSURES_ADDITIONAL ? activeClass : null">
            @if (showSuccessIcon(EditPostingFormNames.DISCLOSURES_ADDITIONAL)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a [tabIndex]="disableLinksForHold ? -1 : 0" data-track-elem="tab" data-track-trigger="switch" data-track-name="Disclosure Details" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.DISCLOSURES_ADDITIONAL)"
              [ngClass]="selectedPostingForm == EditPostingForms.DISCLOSURES_ADDITIONAL ? activeClass : null"
              role="navigation" [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehicleAdditional')"
              [ngStyle]="{'pointer-events': disableLinksForHold ? 'none' : 'auto', color: disableLinksForHold ? '#959595' : ''}">
              {{convert('sellModule.posting.editPostingNav.textAdditional')}}
            </a>
          </div>
        </li>
      </ul>
    </nav>
    <nav class="edit-posting-nav" aria-labelledby="edit-posting-nav-vehicle-pricing">
      <div class="edit-posting-nav__label" id="edit-posting-nav-vehicle-pricing">{{convert('sellModule.posting.editPostingNav.textVehiclePricing')}}</div>
      <ul class="edit-posting-nav__list">
        <li class="edit-posting-nav__list-item">
          <div class="row navRow" [ngClass]="selectedPostingForm == EditPostingForms.PRICING_PRICING_AND_FEES ? activeClass : null">
            @if (showErrorIcon(EditPostingFormNames.PRICING_PRICING_AND_FEES)) {
              <div class="error-icon">
                <app-error-icon class="required-item-error-message" [remValue]="'0.75rem'"></app-error-icon>
              </div>
            }
            @if (showSuccessIcon(EditPostingFormNames.PRICING_PRICING_AND_FEES)) {
              <div class="success-icon">
                <i class="allycon-success-fill text-success" aria-hidden="true"></i>
              </div>
            }
            <a data-track-elem="tab" data-track-trigger="switch" data-track-name="Pricing and Fees" class="edit-posting-nav__link"
              href="javascript:void(0);" (click)="navigateTo(EditPostingForms.PRICING_PRICING_AND_FEES)"
            [ngClass]="{'edit-posting-nav__link--active': selectedPostingForm == EditPostingForms.PRICING_PRICING_AND_FEES,
                      'required-item-error-message' : showErrorIcon(EditPostingFormNames.PRICING_PRICING_AND_FEES)}" role="navigation"
              [attr.aria-label]="convert('sellModule.posting.editPostingNav.ariaLabelVehiclePricingFess')">
              {{convert('sellModule.posting.editPostingNav.textPricingFees')}}
            </a>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</ng-container>
